<template>
  <v-container
    fluid
    class="align-start pa-0"
    :class="
      loading || hasLoadingError || !notifications || !notifications.length
        ? 'fill-height'
        : ''
    "
  >
    <v-row>
      <v-col class="text-start">
        <span class="text-h5 textLight--text font-weight-medium">
          {{ $t("notifications.notifications") }}
        </span>
      </v-col>
    </v-row>

    <v-row v-if="loading" align="center">
      <v-col>
        <v-progress-circular indeterminate />
      </v-col>
    </v-row>

    <v-row v-else-if="hasLoadingError" align="center">
      <v-col>
        <div class="subtitle-1 text-capitalize hand-cursor">
          <v-icon color="error"> mdi-replay </v-icon>

          <p>
            {{ $t("retry") }}
          </p>
        </div>
      </v-col>
    </v-row>

    <template v-else-if="notifications">
      <template v-if="notifications.length">
        <v-row
          v-for="(data, index) in notifications"
          :key="`notification_simple_${index}`"
          align="start"
        >
          <v-col cols="12" class="py-2">
            <NotificationAlert :data="data" />
          </v-col>
        </v-row>

        <v-row v-if="totalNotificationsCount > 3">
          <v-col cols="12" class="py-0">
            <div class="d-flex justify-end subtitle-2 textLight--text">
              <p @click="navigateToNotificationsPage" class="ma-0 hand-cursor">
                {{ $t("user.registration.viewAll") }}
              </p>
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row>
          <v-col>
            <span class="subtitle-2 textLight--text">
              {{ $t("notifications.noNotifications") }}
            </span>
          </v-col>
        </v-row>
      </template>
    </template>
  </v-container>
</template>

<script>
import NotificationAlert from "@/app/core-module/components/NotificationAlert";

export default {
  name: "NotificationAlertList",
  components: { NotificationAlert },
  data() {
    return {
      loading: true,
      hasLoadingError: false,
      notifications: null,
      totalNotificationsCount: 0,
    };
  },
  apollo: {
    getNotifications() {
      return {
        query: require("../api/query/getNotifications.gql"),
        variables: {
          pageInput: {
            skip: 0,
            limit: 10,
          },
        },
        result({ data, loading }) {
          if (data?.getNotifications?.notifications) {
            this.notifications = data?.getNotifications?.notifications?.slice(
              0,
              3
            );

            this.totalNotificationsCount = data?.getNotifications.totalCount;
          } else {
            this.hasLoadingError = true;
          }

          this.loading = loading;
        },
      };
    },
  },
  methods: {
    navigateToNotificationsPage() {
      this.$router.push({
        name: "Notifications",
      });
    },
  },
};
</script>
